import React from 'react'
import { ReactComponent } from './colisactiv.svg'
import { MergeReactElementProps } from '../types'

interface ColisactivLogoSvgProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', ColisactivLogoSvgProps>

export const ColisactivLogoSvg = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
